import React, { useEffect, useState } from "react";
import {
  Content,
  Col,
  Box,
  Button,
  SimpleTable,
} from "adminlte-2-react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment-timezone";
import "react-big-calendar/lib/css/react-big-calendar.css";
import _ from "lodash";
import controller from "../reservas/duck";
import controllerLocal from "../locales/duck";
import { useSelector, useDispatch } from "react-redux";
import { parseJwt } from "../utils/utils";
import Loader from "../utils/Loader";
import DatePicker from "react-datepicker";

require("moment/locale/es.js");

const localizer = momentLocalizer(moment);

function CalendarioProfesionales({ history, match }) {
  const dispatch = useDispatch();

  const modelEventos = useSelector((state) => state.reservasEnDia);
  const modelLocal = useSelector((state) => state.localById);
  const [eventos, setEventos] = useState([]);
  const [diaFiltro, setDiaFiltro] = useState(new Date());
  const [datosTabla, setDatosTabla] = useState({});
  const [profesionales, setProfesionales] = useState([]);
  const [local, setLocal] = useState(null);
  const [actualRol, setActualRol] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);


  const [conceptoPintar, setConceptoPintar] = useState("profesional");

  const sumarMinutos = (horaIncial, suma) => {
    const hora = moment(horaIncial, "YYYY-MM-DD HH:mm")
      .add(suma, "minutes")
      .format("YYYY-MM-DD HH:mm");
    return hora;
  };



function handleWindowSizeChange() {
    setWidth(window.innerWidth);
}
useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
}, []);

const isMobile = width <= 768;

  useEffect(() => {
    const data = modelLocal?.data?.data;
    const error = modelLocal?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
    if (data && data.data) {
      setLocal(data.data);
      dispatch(controllerLocal.duckLocalById.actions.clear());
    }
  }, [modelLocal]);





  useEffect(() => {
    const data = modelEventos?.data?.data;
    const error = modelEventos?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.reservasConfirmadasByLocalDuck.actions.clear());
    }
    if (data) {
      const profesionalesArray = [];

      data.data.forEach((elem) => {
        const exists = profesionalesArray.filter(
          (elem2) => elem2.data === elem?.profesional?.id
        );
        if (exists.length === 0) {
          profesionalesArray.push({
            data: elem?.profesional?.id,
            title: elem?.profesional?.nombre,
          });
        }
      });

      console.log("DATAAA: ", data.data);
      if(profesionalesArray.length === 0) {
        alert("No hay profesionales agendados para esta fecha");
      }

      setProfesionales(profesionalesArray);
      const result = data.data.map((row) => {
        const final = row.duracion
          ? sumarMinutos(moment(row.fecha), row.duracion)
          : row.fecha;

        const origen = row?.detalles?.origen ? row?.detalles?.origen : "ADMIN";

        const title = row?.detalles?.profesionalNombre
          ? `${row.hora} - ${row.detalles.nombre} - ${row.detalles.servicioNombre} - ${row.detalles.profesionalNombre} - ${origen}`
          : `${row.detalles.nombre} - ${row.detalles.servicioNombre} - ${row.detalles.ambienteNombre} - ${row.detalles.validoPara} personas - ${origen}`;

        const reg = {
          title,
          start: moment(row.fecha).utc().toDate(),
          end: moment(final).utc().toDate(),
          allDay: row?.detalles?.profesionalNombre ? false : true,
          resource: row,
        };
        return reg;
      });
      const reservasIndexadasPorProfesional = {};
      const reservasIndexadasPorProfesionalConCalendario = {};
      result.forEach((elem) => {
        if (!reservasIndexadasPorProfesional[elem.resource?.profesional?.id]) {
          reservasIndexadasPorProfesional[elem.resource?.profesional?.id] = [];
        }
        reservasIndexadasPorProfesional[elem.resource?.profesional?.id].push(
          elem
        );
      });
      setEventos(reservasIndexadasPorProfesional);
      const formattedDate = getDateUtc(diaFiltro)
    
      const dateSplitted = formattedDate.split('-');
 
      const anho = Number(dateSplitted[0]);
      const mes = Number(dateSplitted[1])-1;
      const dia = Number(dateSplitted[2]);
      profesionalesArray.forEach((row) => {
        reservasIndexadasPorProfesionalConCalendario[row.data] = (
          <Calendar
            responsive={true}
            localizer={localizer}
            events={reservasIndexadasPorProfesional[row.data]}
            startAccessor="start"
            endAccessor="end"
            defaultView="day"
            views={["day"]}
            toolbar={false}
            defaultDate={new Date(anho, mes, dia)}
            style={{
              height: isMobile ? 1100 : 1400,
              width: isMobile ? 350 : profesionalesArray.length >= 5 ? 400 : 'auto',
            }}
            onSelectEvent={(event) => {
              if (event.resource.detalles) {
                history.push(`/reserva/${event.resource._id}`);
              }
            }}
            messages={{
              next: "Sig",
              previous: "Ant",
              today: "Hoy",
              month: "Mes",
              week: "Semana",
              day: "Día",
            }}
            eventPropGetter={eventStyleGetter}
          />
        );
      });
      setDatosTabla(reservasIndexadasPorProfesionalConCalendario);

      dispatch(controller.reservasConfirmadasByLocalDuck.actions.clear());
    }
  }, [modelEventos]);

  // mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      return history.push("/logout");
    }

    const decodedToken = parseJwt(token);

    setActualRol(decodedToken.rol);

    // Al cargar el calendario, la vista por defecto es el mes.
    // El último día que muestra es el primer domingo a partir del
    // último día del mes actual.
    // Se consulta a backend reservas hasta esa fecha.
    // Otros métodos para traer última fecha mostrada
    // (al cargar el calendario)
    // no funcionaron.

    dispatch(controller.reservasEnDiaThunk(match.params.organizacion, getDateUtc(diaFiltro)));
    dispatch(controllerLocal.localByIdThunk(match.params.organizacion));
  }, []);

  const eventStyleGetter = (event, start, end, isSelected) => {
    let style = {};

    if (
      local &&
      event?.resource?.detalles?.foreignKey &&
      local.profesionales[event.resource.detalles.foreignKey] &&
      local.profesionales[event.resource.detalles.foreignKey].color &&
      conceptoPintar === "profesional"
    ) {
      style.backgroundColor =
        local.profesionales[event.resource.detalles.foreignKey].color;
    } else if (
      local &&
      event?.resource?.detalles?.servicioId &&
      conceptoPintar === "servicio"
    ) {
      const servicio = local.servicios.filter(
        (elem) => elem.id === event?.resource?.detalles?.servicioId
      );
      if (servicio && servicio[0] && servicio[0].color) {
        style.backgroundColor = servicio[0].color;
      }
    } else if (event.resource.ausencia) {
      style.backgroundColor = "#c92f1e";
    } else if (event.resource.cantidadDisponible) {
      style.backgroundColor = "#35c456";
    }

    return {
      style: style,
    };
  };

  const getDateUtc = (fecha) => {
    const day = fecha
      ? moment(fecha).utc().format("YYYY-MM-DD")
      : moment().utc().format("YYYY-MM-DD");
    return day;
  };

  const filtrar = () => {
    setDatosTabla({});
    if (!diaFiltro) {
      return alert("Por favor complete los filtros");
    }
    dispatch(
      controller.reservasEnDiaThunk(
        match.params.organizacion,
        getDateUtc(diaFiltro)
      )
    );
  };

  return (
    <Content
      title="Bienvenido"
      browserTitle="Bienvenido a Agendia"
      show={false}
    >
      <Col md="12">
        <Box title="Filtro">
          <Col md="12" style={{ marginBottom: 25 }}>
            <Col md="3">
              <label>Fecha de inicio</label>
              <DatePicker
                dateFormat="dd/MM/yyyy"
                customInput={<input type="text" className="form-control" />}
                selected={diaFiltro}
                onChange={(date) => {
                  setDiaFiltro(date);
                }}
                // minDate={new Date()}
              />
            </Col>

            <Col md="3">
              <div style={{ marginTop: 25 }}>
                <Button
                  type="primary"
                  text="Filtrar"
                  onClick={() => filtrar(0)}
                />
              </div>
            </Col>
          </Col>
        </Box>
        <Box title={`Reservas del ${getDateUtc(diaFiltro)}`}>
          <Loader isLoading={modelEventos.loading}>
            <div
              style={{
                display: "flex",
                flex: "1 1 auto",
                overflowY: "hidden",
                overflowX: "scroll",
              }}
            >
              <SimpleTable
                hover={true}
                data={Object.keys(datosTabla).length > 0 ? [datosTabla] : []}
                columns={profesionales}
              />
            </div>
          </Loader>
        </Box>
      </Col>
    </Content>
  );
}

export default CalendarioProfesionales;
